import * as React from "react";
import { Route, Switch } from "react-router";
import { CommonStateWrapper } from "../state/commonStateWrapper";
import { NavigationContext } from "../state/navigationContext";
import { PatientContext } from "../state/patientContext";
import { MainLayout } from "./MainLayout";
import { PatientSettingsPage } from "../settings/PatientSettingsPage";
import { useQueryParams } from "fe-common/useQueryParams";

// Renders all inner app, statefull components
export const PatientInnerApp = () => {
  const queryParams = useQueryParams();

  const partnerId = queryParams.get("pid");

  const ignoreCache = queryParams.has("noCache");

  return (
    <Switch>
      <Route
        path={["/clinic/:clinic?", ""]}
        render={({ match }) => {
          return (
            <CommonStateWrapper
              widgetSettings={{
                partnerId,
                clinicId: match.params["clinic"],
                ignoreCache,
              }}
            >
              {/* PatientContext is dependent on dao, and conversation context
          so it can't be part of the commonStateWrapper */}
              <NavigationContext>
                <PatientContext>
                  <Switch>
                    <Route
                      path={`${match.path}/settings/:key?`}
                      component={PatientSettingsPage}
                    />
                    <Route
                      render={() => (
                        <MainLayout clinicId={match.params["clinic"]} />
                      )}
                    />
                  </Switch>
                </PatientContext>
              </NavigationContext>
            </CommonStateWrapper>
          );
        }}
      />
    </Switch>
  );
};
